import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AutoCompleteCompleteEvent, AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { plainToInstance } from 'class-transformer';
import { FormsModule } from '@angular/forms';
import { DatePipe, NgIf, SlicePipe } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { MedicalService } from '../../../../services/medical.service';
import { Diagnosis } from '../../../../models/procedure';

@Component({
  selector: 'app-diagnosis-selector',
  standalone: true,
  imports: [AutoCompleteModule, FormsModule, DatePipe, CardModule, ButtonModule, SlicePipe, NgIf],
  templateUrl: './diagnosis-selector.component.html',
  styleUrl: './diagnosis-selector.component.scss'
})
export class DiagnosisSelectorComponent 
{
  @Input() diagnoses? : Diagnosis[] = [];
  @Output() diagnosesChange : EventEmitter<Diagnosis[]> = new EventEmitter<Diagnosis[]>();
  @Output() diagnosesSelected = new EventEmitter<Diagnosis[]>();

  constructor(private _medicalService:MedicalService)
  {

  }

  diagnosisSuggestions: Diagnosis[] = [];

  diagnosisSearch(event:AutoCompleteCompleteEvent)
  {
    //Update the suggestions to our query results
    this._medicalService.searchDiagnoses(event.query)
    .then
    (
      diagnoses => 
        {
          this.diagnosisSuggestions = diagnoses;
        }
    )
  }

  selectDiagnosis(event: AutoCompleteSelectEvent)
  {
    const instances = this.diagnoses?.map(d => plainToInstance(Diagnosis, d));
    this.diagnosesChange.emit(instances);
    this.diagnosesSelected.emit(instances);
  }

  resetSelection()
  {
    this.diagnoses = undefined;
  }
}
